import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiService, ValidatorService} from "@amlCore/services";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {CustomValidatorError} from "@amlCore/utils";
import {PageContentModel, ValidatorParamsModel} from "@amlCore/models";
import {ClientTypeEnum} from "@amlCore/enums";
import {Qref281fzModel} from "../../model/qref281fz.model";
import moment from "moment/moment";
import {atLeastOne} from "@amlCore/validators";

@Injectable()
export class Qref281fzService {


  constructor(private apiService: ApiService,
              private fb: FormBuilder,
              private validatorService: ValidatorService) {
  }


  /**
   * Получить список
   */
  getList(params: any): Observable<PageContentModel<Qref281fzModel>> {
    return this.apiService.get("/api/v1/qref/281fz", params, 'id');
  }

  /**
   * Получение записи по id
   * @param id - id
   */
  getQref281fz(id: string): Observable<Qref281fzModel> {
    return this.apiService.get(`/api/v1/qref/281fz/${id}`);
  }

  /**
   * Создание/обновление
   * @param data - данные
   */
  saveQref281fz(data: Qref281fzModel): Observable<any> {
    return this.apiService.post('/api/v1/qref/281fz', data);
  }

  getForm(): FormGroup {
    return this.fb.group({
      id: null,
      recordNum:  [null, this.validatorService.getValidation({
        isReq: true,
        max: 3
      })],
      type: [null, this.validatorService.getValidation({
        isReq: true
      })],
      orgNameRu: null, // валидиация в orgNameValidator
      orgNameIn: null, // валидиация в orgNameValidator
      regNum: null,
      allName: [null, this.validatorService.getValidation({
        isReq: true
      })],
      birthDate: null,
      adress: null,
      dateIn: [null, this.validatorService.getValidation({
        isReq: true
      })],
      npaIn:  [null, this.validatorService.getValidation({
        isReq: true
      })],
      dateModify: null,
      npaModify: null,
      dateOut: null,
      npaOut: null
    }, {
      validators: [this.orgNameValidator({ 'orgNameEmpty': true }),
        this.reasonsRequiredValidator('dateModify', 'npaModify'),
        this.reasonsRequiredValidator('dateOut', 'npaOut')]
    });
  }

 /**
   * Столбец "Наименование/ФИО"
   * @param item - строка
   */
  getName(item: Qref281fzModel): string {
    return '2' == item.type ? item.allName :
      [item.orgNameRu, item.orgNameIn].filter(Boolean).join(", ") ;
  }

  orgNameValidator(validatorField: { [key: string]: boolean }): ValidatorFn {
    return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.get('type')?.value == '1' && checkEmpty(c.get('orgNameRu')) && checkEmpty(c.get('orgNameIn'))) {
        return validatorField;
      }
      return null;
    };

    function checkEmpty(item: AbstractControl) {
      return !(item || {}).value || item.value && item.value === "";
    }
  }

  reasonsRequiredValidator = (fieldDate: string, fieldNpa: string): ValidatorFn =>
    (form: FormControl): ValidationErrors | null => {
      const dateModifyControl = form.get(fieldDate);
      const npaModifyControl = form.get(fieldNpa);
      if (dateModifyControl) {
        dateModifyControl.setValidators(!checkEmpty(npaModifyControl) ? [Validators.required] : null);
        dateModifyControl.updateValueAndValidity({onlySelf: true});
      }
      if (npaModifyControl) {
        npaModifyControl.setValidators(!checkEmpty(dateModifyControl) ? [Validators.required] : null);
        npaModifyControl.updateValueAndValidity({onlySelf: true});
      }
      return null;

      function checkEmpty(item: AbstractControl) {
        return !(item || {}).value || item.value && item.value === "";
      }
    };

}
